export { metricInit as awsMetricInit, metricPublisher as awsMetricPublisher } from './aws';
